import { registerComponent } from "helpers";

registerComponent(
  "wyatt-view-all",
  class WyattViewAllButton extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleViewAll.bind(this);
      this.addEventListener("click", this.handleClick);
    }

    connectedCallback() {
      this.targetSelector = this.dataset.targetContent;
      this.targetElement = document.querySelector(`[${this.targetSelector}]`);
      this.viewAllTextElement = this.querySelector("[data-view-all-text]");
      this.arrowIcon = this.querySelector(".view-all__icon");

      if (this.targetElement) {
        this.partialHeight = this.dataset.partialHeight || "300px";
        this.expanded = false;

        this.targetElement.style.maxHeight = this.partialHeight;
        this.targetElement.style.overflow = "hidden";
      }
    }

    handleViewAll() {
      if (!this.targetElement) {
        return;
      }

      if (this.expanded) {
        this.targetElement.style.maxHeight = this.partialHeight;
        this.viewAllTextElement.textContent = "View More";
        this.arrowIcon.classList.remove("icon--rotate");
      } else {
        this.targetElement.style.maxHeight = "none";
        this.viewAllTextElement.textContent = "View Less";
        this.arrowIcon.classList.add("icon--rotate");
      }

      this.expanded = !this.expanded;
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
    }
  },
);
